import {
  ENTRY_DATA_SECTION_KEYS as SECTION_KEYS,
  ENTRY_DATA_INVESTORS_GROUP_TABLE_KEY as INVESTORS,
  ENTRY_DATA_INVESTORS_SHELL_KEYS as INVESTORS_SHELL_KEYS,
} from "@frontend/common";

import { ArticleEntryData } from "@/types/articleEntryData.types";
import { EntryDataInvestorValue } from "@/types/ventureCapital.types";
import { useTableCreatorFocusStatus } from "@FillInTableContainer/shared/context/TableCreatorFocusStatusContext";
import {
  DEFAULT_POSITION_INFO,
  useTableCreatorPositionInfo,
} from "@FillInTableContainer/shared/context/TableCreatorPositionInfoContext";
import { useEntryDataState } from "@stores/entryData";
import { getPressIdFromURL } from "@utils/getStateFromURL";

const sectionKey = SECTION_KEYS.ventureCapital;
const groupTableKey = INVESTORS;
const shellKey = INVESTORS_SHELL_KEYS.investorName;
export const useInvestorTableValueDelete = () => {
  const [entryData, setEntryData] = useEntryDataState(getPressIdFromURL());
  const { changeFocusStatus } = useTableCreatorFocusStatus();
  const { changeInfo } = useTableCreatorPositionInfo();

  const deleteInvestorTableValue = (valueIndex: number) => {
    const updatedEntryData = {
      ...entryData,
      [sectionKey]: {
        ...entryData[sectionKey],
        [groupTableKey]: {
          ...entryData?.[sectionKey]?.[groupTableKey],
          [shellKey]: {
            ...entryData?.[sectionKey]?.[groupTableKey]?.[shellKey],
            value: entryData?.[sectionKey]?.[groupTableKey]?.[shellKey]?.value
              ?.map((value, index) => (index === valueIndex ? null : value))
              .filter((value) => value !== null) as EntryDataInvestorValue[],
          },
        },
      },
    };

    setEntryData(updatedEntryData as ArticleEntryData);
    changeFocusStatus({
      type: "default",
      container: "noFocus",
    });
    changeInfo(DEFAULT_POSITION_INFO);
  };

  return { deleteInvestorTableValue };
};
